export const SideContainer = ({ children }) => {
  return (
    <div className="flex flex-grow lg:flex-grow-0 md:w-48 xl:w-56">
      {children}
    </div>
  );
};
